(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal','$state'];

    function PasswordController (Auth, Principal, $state) {
        var vm = this;
        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;
        vm.passwords = {};

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
               vm.password =  vm.confirmPassword;
                vm.doNotMatch = null;
                //vm.passwords.oldPassword =vm.oldPassword;
                //vm.passwords.newPassword = vm.password;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                    Principal.identity(true).then(function(account) {
                        vm.account = account;
                        gotoHome();
                    });

                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }

        function gotoHome() {

            var adminAuthorities = ['Administrators'];
            Principal.hasAuthority(Principal.findHasAnyAuthority(adminAuthorities)).then(function(result) {
                vm.isAdmin = result;

                if (vm.isAdmin === true && Principal.isAuthenticated()) {
                    $state.go('home-main.home-page', {}, {
                        reload: true
                    });
                }
                else if (vm.isAdmin === false && Principal.isAuthenticated()) {
                    $state.go('user-home-page', {}, {
                        reload: true
                    });
                }
            });
        }
    }
})();
